import { w as withConfigTransport } from "../../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaDataTableThRow } from "./VaDataTableThRow-d9ca8c32.mjs";
const VaDataTableThRow = withConfigTransport(_VaDataTableThRow);
export {
  VaDataTableThRow as V
};
//# sourceMappingURL=index-3a455199.mjs.map
